import { render, staticRenderFns } from "./SlidingPanel.vue?vue&type=template&id=fc342da4&scoped=true"
import script from "./SlidingPanel.vue?vue&type=script&lang=js"
export * from "./SlidingPanel.vue?vue&type=script&lang=js"
import style0 from "./SlidingPanel.vue?vue&type=style&index=0&id=fc342da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc342da4",
  null
  
)

export default component.exports